enum RedirectEffectTargetType {
  NOTE = 'note',
  QUOTE = 'quote',
  TASK = 'task',
  COMPANY = 'company',
  FILE = 'file',
}

export default RedirectEffectTargetType;
